export default "__VITE_ASSET__HJPpNrSV__"